import * as MuiRating from '@mui/material/Rating'
import React from 'react'

export type RatingProps = MuiRating.RatingProps

export function Rating({ ...props }: RatingProps) {
  return <MuiRating.default {...props} />
}
